module.exports = __webpack_public_path__ + "img/tech-specs-main-product-image.1c370768.png";